import 'bootstrap';
import * as all from './main';

all.customScripts();